import ApplyButton from "@/components/atomics/apply-button";
import Button from "@/components/atomics/button";
import CopyToClipboard from "@/components/atomics/copytoClipboard";
import Statistics from "@/components/molecules/referal/statistics";
import { backend } from "@/services/backend";
import React, { useEffect, useState } from "react";
import { ReferralStatsExtended } from "@/services/types";
import MotionModal from "@/components/atomics/motion-modal";
import Help from "@/components/atomics/help";
import { referralHelp } from "@/data/referral-help";

interface ReferralDashboardProps {
  className?: string;
  isEditView?: boolean;
  walletAddress: string | null | undefined;
  referralData?: ReferralStatsExtended | null;
  referralCount?: number;
  referralAddress?: string | null;
}

type HelpType = "referral_link" | "partner_link" | "claim";

export default function ReferralDashboard({
  className,
  walletAddress,
  isEditView,
  referralData,
}: ReferralDashboardProps) {
  const [showHelp, setShowHelp] = useState(false);
  const [currentHelpType, setCurrentHelpType] =
    useState<HelpType>("referral_link");

  const displayReferralCount = referralData?.referral_count || 0;
  const displayReferralCollections =
    referralData?.referral_collection_count || 0;
  const displayReferralNftMinted = referralData?.referral_item_count || 0;
  const displayTotalEarned =
    Math.round(((referralData?.total_income || 0) / 1e9) * 100) / 100;
  const displayReferralPercent = referralData?.referral_percent || 5;

  const handleShowHelp = (helpType: HelpType) => {
    setCurrentHelpType(helpType);
    setShowHelp(true);
  };

  const currentHelp = referralHelp[currentHelpType];

  return (
    <div className={`${className}`}>
      <MotionModal isOpen={showHelp}>
        <Help
          className="w-full bg-black"
          onClose={() => setShowHelp(false)}
          onOk={() => setShowHelp(false)}
          title={currentHelp.title}
          description={currentHelp.description}
        />
      </MotionModal>
      <div>
        <div className={`text-[32px] flex  gap-[10px] pb-[5px]`}>
          <span className={`${isEditView ? "text-[25px]" : "text-[32px]"}`}>
            MY REF. LINK
          </span>
          <span
            className="text-[#0099FE] text-[28px] hover:cursor-pointer"
            onClick={() => handleShowHelp("referral_link")}
          >
            ?
          </span>
        </div>
        <CopyToClipboard
          className={`pt-[10px] pb-[10px]`}
          length={7}
          text={`https://app.simplenft.io/?ref=${walletAddress}` || ""}
        />
      </div>
      <div className="pb-[20px]">
        <div className={`text-[32px] flex  gap-[10px] pb-[5px]`}>
          <span className={`${isEditView ? "text-[25px]" : "text-[32px]"}`}>
            PARTNER LINK
          </span>
          <span
            className="text-[#0099FE] text-[28px] hover:cursor-pointer"
            onClick={() => handleShowHelp("partner_link")}
          >
            ?
          </span>
        </div>
        <CopyToClipboard
          className={`pt-[10px] pb-[10px] pointer-events-none opacity-40`}
          length={7}
          text={`https://app.simplenft.io/?ref=${walletAddress}` || ""}
        />
      </div>
      <div className="pr-[40px] pl-[40px] flex items-center">
        <ApplyButton
          className={`w-full text-[26px]`}
          image="/assets/button.svg"
          text="APPLY FORM"
          onClick={() => {
            window.open("https://forms.gle/t2iznuN4TbqoG1r8A", "_blank");
          }}
        />
      </div>

      <Statistics
        className={`pt-[20px]`}
        referralCount={displayReferralCount}
        collectionsCreated={displayReferralCollections}
        nftMinted={displayReferralNftMinted}
        referralsCashback={`${displayReferralPercent}%`}
        tonsCollected={displayTotalEarned}
      />
      <div className="relative flex items-center justify-center pt-[35px] pb-[48px] gap-[10px]">
        <div className="pr-[40px] pl-[40px]">
          <Button
            className={`w-full text-[24px]`}
            image={"/assets/disabled-button.svg"}
            text={`CLAIM ${displayTotalEarned} TON`}
            disabled={true}
          />
        </div>
        <span
          className="absolute right-[0px] text-[#0099FE] text-[28px] hover:cursor-pointer"
          onClick={() => handleShowHelp("claim")}
        >
          ?
        </span>
      </div>
    </div>
  );
}
